/**
 * Утилиты для поиска словарей
 */

// Подавление логов, если DEBUG=false
(function() {
  if (typeof window !== 'undefined' && window.DEBUG === false) {
    var noop = function() {};
    console.log = noop;
    console.warn = noop;
    // console.error оставляем для критических ошибок
  }
})();

// HTML escaper for text AND double/single-quoted attribute values (BL-047/BL-050):
// the old textContent→innerHTML trick left `"` and `'` unescaped.
function escapeHtml(text) {
  if (text === null || text === undefined) {
    return '';
  }
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// Only `data-*` attributes with a plain double-quoted value survive on a kept <r> tag.
var R_ATTRS_SAFE = /^(\s+data-[a-z0-9-]+="[^"<>&]*")*\s*$/i;

// Удаление HTML-тегов из терминов: декодирует HTML-сущности и удаляет теги.
// keepR falsy → PLAIN TEXT (put it into the DOM only via textContent or escapeHtml).
// keepR true  → HTML-SAFE markup: the text is escaped and only the <r> tags come back
// (with data-* attributes only). A decoded `&lt;img …&gt;` must never become a tag
// (BL-047: stored XSS via community headwords).
function stripHtmlTags(text, keepR) {
  if (!text) {
    return text;
  }

  var rTags = [];
  if (keepR) {
    // Private-use placeholders survive innerHTML/textContent unchanged.
    text = String(text).replace(/<r(\s[^>]*)?>/gi, function(m, attrs) {
      attrs = attrs || '';
      rTags.push('<r' + (R_ATTRS_SAFE.test(attrs) ? attrs : '') + '>');
      return '' + (rTags.length - 1) + '';
    });
    text = text.replace(/<\/r>/gi, '');
  }

  // Создаем временный элемент для декодирования HTML-сущностей
  var temp = document.createElement('div');
  temp.innerHTML = text;

  // Получаем текстовое содержимое (автоматически удаляет остальные теги)
  var cleanText = temp.textContent || temp.innerText || '';

  if (keepR) {
    cleanText = escapeHtml(cleanText);
    cleanText = cleanText.replace(/(\d+)/g, function(m, i) {
      return rTags[+i] || '';
    });
    cleanText = cleanText.replace(//g, '</r>');
  }

  return cleanText;
}

// Фиксируем ширину страницы, чтобы избежать прыжков при появлении скроллбара
(function() {
  function fixScrollbarWidth() {
    // Вычисляем ширину скроллбара
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    
    // Типичная ширина скроллбара в разных браузерах (15-17px)
    // Используем максимальное значение для надежности
    var expectedScrollbarWidth = 17;
    
    // Если скроллбар виден, используем его реальную ширину
    // Если нет, резервируем стандартное место
    var finalWidth = scrollbarWidth > 0 ? scrollbarWidth : expectedScrollbarWidth;
    
    // Применяем padding-right к html для компенсации (более надежно чем body)
    document.documentElement.style.paddingRight = finalWidth + 'px';
  }
  
  // Вызываем при загрузке
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixScrollbarWidth);
  } else {
    fixScrollbarWidth();
  }
  
  // Обновляем при изменении размера окна
  window.addEventListener('resize', fixScrollbarWidth);
  
  // Также обновляем после загрузки всех ресурсов
  window.addEventListener('load', fixScrollbarWidth);
})();

// Функции для работы с cookies
function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  // Устанавливаем cookie для всего домена (path=/)
  document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
}

function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
}

// Сохранение языка в cookies (срок действия 365 дней)
function saveLanguage(lang) {
  if (lang && ['en', 'ru', 'de', 'fr'].includes(lang)) {
    setCookie('slovary_lang', lang, 365);
  }
}

// Сохранение режима поиска в cookies (срок действия 365 дней)
function saveSearchType(searchType) {
  // Миграция старых значений перед сохранением
  if (searchType === 'exact' || searchType === 'broad' || searchType === 'description' || searchType === '') {
    searchType = 'classical';
  } else if (searchType === 'broad-with-vector') {
    searchType = 'smart';
  } else if (searchType === 'broad-without-vector') {
    searchType = 'classical';
  }

  // Сохраняем только валидные новые значения
  if (searchType === 'smart' || searchType === 'classical') {
    setCookie('slovary_search_type', searchType, 365);
  }
}

// Получение сохраненного языка из cookies
function getSavedLanguage() {
  return getCookie('slovary_lang');
}

// Получение сохраненного режима поиска из cookies
function getSavedSearchType() {
  var savedType = getCookie('slovary_search_type');
  
  // Миграция старых значений при получении
  if (savedType === 'exact' || savedType === 'broad' || savedType === 'description' || savedType === '') {
    return 'classical';
  } else if (savedType === 'broad-with-vector') {
    return 'smart';
  } else if (savedType === 'broad-without-vector') {
    return 'classical';
  }
  
  return savedType;
}

// Восстановление режима поиска из cookies
function restoreSearchType() {
  var savedType = getSavedSearchType();
  if (!savedType || (savedType !== 'smart' && savedType !== 'classical')) {
    savedType = 'smart'; // Default to smart if invalid
  }
  
  // Поддержка новой кнопки-переключателя
  var searchModeToggle = document.getElementById('search-mode-toggle');
  var searchTypeHidden = document.getElementById('search-type-hidden');
  
  if (searchModeToggle && searchTypeHidden) {
    // Обновляем новую кнопку-переключатель
    searchModeToggle.setAttribute('data-mode', savedType);
    searchTypeHidden.value = savedType;
    
    // Обновляем класс active для визуального состояния
    if (savedType === 'smart') {
      searchModeToggle.classList.add('active');
    } else {
      searchModeToggle.classList.remove('active');
    }
    
    // Chip label and tooltip come from localization (LANG_TEXTS); when the
    // language is not known yet, keep what the server rendered.
    var lang = (window.SEARCH_STATE && window.SEARCH_STATE.getCurrentLang) ? window.SEARCH_STATE.getCurrentLang() : null;
    var texts = (lang && typeof LANG_TEXTS !== 'undefined') ? LANG_TEXTS[lang] : null;
    if (texts) {
      var label = searchModeToggle.querySelector('.search-mode-label');
      if (label && texts.search_mode_label) {
        label.textContent = texts.search_mode_label;
      }
      searchModeToggle.title = (savedType === 'smart') ? (texts.search_type_smart_desc || 'Smart') : (texts.search_type_classical_desc || 'Classical');
    }
    
    return true;
  }
  
  return false;
}

// Получение настройки клика для поиска
function isClickSearchEnabled() {
  var value = getCookie('slovary-click-search');
  return value === 'true';
}

// Функция для определения мобильного устройства
function isMobileDevice() {
  return window.innerWidth <= 991 || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

/**
 * Инициализация кастомных тултипов для десктопа
 */
function initCustomTooltips() {
  if (isMobileDevice()) return;

  var tooltipEl = null;
  var hideTimeout = null;

  function createTooltip() {
    if (tooltipEl) return tooltipEl;
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'custom-tooltip';
    document.body.appendChild(tooltipEl);
    return tooltipEl;
  }

  function showTooltip(target) {
    // Если у элемента появился title (например, после смены языка), обновляем data-tooltip
    if (target.title) {
      target.setAttribute('data-tooltip', target.title);
      target.removeAttribute('title');
    }

    var text = target.getAttribute('data-tooltip');
    if (!text) return;

    var el = createTooltip();
    el.textContent = text;
    el.classList.add('visible');

    var rect = target.getBoundingClientRect();
    var tooltipRect = el.getBoundingClientRect();
    
    // Позиционируем над элементом по умолчанию
    var top = rect.top - tooltipRect.height - 12;
    var left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
    el.classList.remove('pos-bottom');
    el.classList.add('pos-top');

    // Если сверху не влезает, переносим вниз
    if (top < 10) {
      top = rect.bottom + 12;
      el.classList.remove('pos-top');
      el.classList.add('pos-bottom');
    }

    // Проверка границ экрана по горизонтали
    if (left < 10) left = 10;
    if (left + tooltipRect.width > window.innerWidth - 10) {
      left = window.innerWidth - tooltipRect.width - 10;
    }

    el.style.top = top + 'px';
    el.style.left = left + 'px';
  }

  function hideTooltip() {
    if (tooltipEl) {
      tooltipEl.classList.remove('visible');
    }
  }

  document.addEventListener('mouseover', function(e) {
    var target = e.target.closest('[data-tooltip], [title]');
    if (target && !isMobileDevice()) {
      if (target.classList.contains('search-mode-toggle') || 
          target.id === 'search-mode-toggle' || 
          target.classList.contains('search-history-button-new')) {
        clearTimeout(hideTimeout);
        showTooltip(target);
      }
    }
  });

  document.addEventListener('mouseout', function(e) {
    var target = e.target.closest('[data-tooltip]');
    if (target) {
      hideTimeout = setTimeout(hideTooltip, 100);
    }
  });
}

// Экспортируем глобально
window.escapeHtml = escapeHtml;
window.stripHtmlTags = stripHtmlTags;
window.setCookie = setCookie;
window.getCookie = getCookie;
window.saveLanguage = saveLanguage;
window.saveSearchType = saveSearchType;
window.getSavedLanguage = getSavedLanguage;
window.getSavedSearchType = getSavedSearchType;
window.restoreSearchType = restoreSearchType;
window.isClickSearchEnabled = isClickSearchEnabled;
window.isMobileDevice = isMobileDevice;
window.initCustomTooltips = initCustomTooltips;

window.SEARCH_UTILS = {
  escapeHtml: escapeHtml,
  stripHtmlTags: stripHtmlTags,
  setCookie: setCookie,
  getCookie: getCookie,
  isClickSearchEnabled: isClickSearchEnabled,
  saveLanguage: saveLanguage,
  saveSearchType: saveSearchType,
  getSavedLanguage: getSavedLanguage,
  getSavedSearchType: getSavedSearchType,
  restoreSearchType: restoreSearchType,
  isMobileDevice: isMobileDevice,
  initCustomTooltips: initCustomTooltips
};

